module.exports = __webpack_public_path__ + "static/media/concierge.faac6e1d.jpg";